import { useMemo } from 'react';
import { timestampIntegrators } from '../../timestampIntegrators';
import { REQUEST, RESPONSE, CREATED_TIMESTAMP } from '../../constants';

export const useMeliIntegrator = (data, pods) => {
  const integratorPods = data?.demandPods?.length ? data?.demandPods : pods;

  const { summary, requestParams, request, response, meliPods } = useMemo(() => {
    const { id, imp, app, device, badv, regs, user } = data?.[REQUEST]?.record?.rawData ?? {};
    return {
      summary: {
        timestamp: timestampIntegrators(data?.[RESPONSE]?.record?.[CREATED_TIMESTAMP]),
        endpoint: '',
        requestID: id,
        ...(imp && { impressionIDs: imp?.map(({ id }) => id) }),
        maxAds: imp?.length,
        maxPodDuration: imp?.reduce((acc, item) => (acc += item?.video?.maxduration), 0),
        appName: app?.bundle,
        appPublisher: app?.publisher?.id,
        playbackType: app?.content?.livestream,
        deviceIP: device?.ip,
        deviceIFA: device?.ifa,
        deviceUserAgent: device?.ua,
        doNotTrack: device?.dnt,
      },
      requestParams: { badv, regs, user, app: { content: app?.content } },
      request: data?.[REQUEST]?.record?.rawData ?? {},
      response: data?.[RESPONSE]?.record?.rawData ?? {},
      meliPods: integratorPods ?? [],
    };
  }, [data, integratorPods]);

  return {
    summary,
    requestParams,
    request,
    response,
    meliPods,
  };
};
